"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLIDER_SKELETON = exports.SKELETON_COUNT = exports.GALLERY_SKELETON = void 0;
const GALLERY_SKELETON = exports.GALLERY_SKELETON = 'gallery-skeleton';
const SLIDER_SKELETON = exports.SLIDER_SKELETON = 'slider-skeleton';
const SKELETON_COUNT = exports.SKELETON_COUNT = 12;
